import React from 'react';
import { Link } from 'react-router-dom';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { Shield, FileText, Mail, LifeBuoy } from 'lucide-react';
import appLogo from '../assets/logo.png';

export default function Footer() {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.1 });

  return (
    <footer
      ref={ref}
      className={`bg-[#070A12] border-t border-gray-800/80 pt-16 pb-12 px-6 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-20'
        }`}
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-12 pb-12 border-b border-gray-800/60">
        <div className="md:col-span-1 flex flex-col gap-4">
          <div className="flex items-center gap-3 font-extrabold text-xl text-white">
            <img src={appLogo} alt="PFP AI Logo" className="w-8 h-8 object-contain" />
            <span>PFP <span className="text-[#E63946]">AI</span></span>
          </div>
          <p className="text-gray-500 text-xs leading-relaxed">
            Revolutionizing photo and video creation with automated generative instructions.
          </p>
        </div>

        <div className="flex flex-col gap-3">
          <div className="flex items-center gap-2 text-sm font-bold text-white mb-1">
            <Shield className="w-4 h-4 text-[#E63946]" /> Legal
          </div>
          <Link to="/privacy" className="text-xs text-gray-400 hover:text-white transition-colors">Privacy Policy</Link>
          <Link to="/terms&condition" className="text-xs text-gray-400 hover:text-white transition-colors">Terms of Service</Link>
        </div>

        <div className="flex flex-col gap-3">
          <div className="flex items-center gap-2 text-sm font-bold text-white mb-1">
            <Mail className="w-4 h-4 text-[#E63946]" /> Contact
          </div>
          <p className="text-xs text-gray-400">svipes.office@gmail.com</p>
          <p className="text-xs text-gray-400">Media Inquiries</p>
        </div>

        <div className="flex flex-col gap-3">
          <div className="flex items-center gap-2 text-sm font-bold text-white mb-1">
            <LifeBuoy className="w-4 h-4 text-[#E63946]" /> Support
          </div>
          <a href="mailto:svipes.office@gmail.com" className="text-xs text-gray-400 hover:text-white transition-colors">Help &amp; Support Center</a>
          <a href="#" className="text-xs text-gray-400 hover:text-white transition-colors">User Instruction Guide</a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-gray-600 text-xs">
        <p>© 2026 PFP AI . All rights reserved.</p>
      </div>
    </footer>
  );
}
